import Image from '@tiptap/extension-image';

export default Image.extend({
    name: 'ResizableImage',
    addAttributes() {
        // Return an object with attribute configuration
        return {
            ...this.parent?.(),

            width: {
                default: '100%',
                renderHTML: (attributes) => {
                    return {
                        width: attributes.width
                    };
                }
            },
            height: {
                default: 'auto',
                renderHTML: (attributes) => {
                    return {
                        height: attributes.height
                    };
                }
            }
        }
    }

});